import React from 'react';
import { Tooltip, Button, InputNumber, Tag } from 'antd';
import { PercentageOutlined, InfoOutlined, EditOutlined } from '@ant-design/icons';
import { copy, withoutId } from '../../utils/data.js';
import uuid from 'react-uuid';
import DivisionalProfitAndLossMenu from './DivisionalProfitAndLossMenu.js';

function DivisionalProfitAndLossColumn(props) {
  if (props.row_type === 'empty') {
    return (
      <div style={{height: '22px'}}>
      </div>
    );
  }  

  function renderDescription() {
    switch (props.row.row_type) {      
      case 'reap-account':      
          return renderReapAccountColumnColor(props.row.description)        
      case 'pal':
        return props.row.description;
      case 'adjustment':
        return props.row.description;
      case 'total':
        return <strong style={{color: '#3D426B'}}>{props.row.name}</strong>
      default:
        return null;
    }
  }

  function renderReapAccountColumnColor(text) {
    const account = props.model.reapAccounts.find(a => a.id === props.row.accountId);

    if (account.xeroAccounts.length > 0) {
      const textColor = (account.category === 'income') ? '#165816' : '#c23b22';
      return (
        <strong  style={{ color: textColor }}>{text}</strong>
      );
    }
    else {
      return <strong style={{ color: '#AAAAAA' }}>{text}</strong>;
    }
  }


  function renderMonth() {
    switch (props.row.row_type) {
      case 'reap-account':
        return renderReapAccountColumnColor(props.row.amount.toFixed(2));
      case 'pal':
        return props.row.amount.toFixed(2);
      case 'adjustment':
        return props.row.amount.toFixed(2);
      case 'total':
        const amount = props.row.amount.toFixed(2);
        if (props.row.name === 'Gross Profit Margin' ||
            props.row.name === 'Net Profit Percentage') {
          return <strong>{`${amount}%`}</strong>
        }
        return <strong>{amount}</strong>
      default:
        return null;
    }
  }

  function renderSales() {
    switch (props.row.row_type) {
      case 'reap-account':
        return <strong>{renderReapAccountColumnColor(props.row.sales.toFixed(2))}</strong>;
      case 'pal':
        return props.row.sales.toFixed(2);
      case 'adjustment':
        return props.row.sales.toFixed(2);      
      case 'total':
        return null;
      default:
        return null;
    }
  }

  function renderPM() {
    switch (props.row.row_type) {
      case 'reap-account':
        return <strong>{renderReapAccountColumnColor(props.row.pm.toFixed(2))}</strong>;
      case 'pal':
        return props.row.pm.toFixed(2);
      case 'adjustment':
        return props.row.pm.toFixed(2);      
      case 'total':
        return null;
      default:
        return null;
    }
  }

  function renderDir() {
    switch (props.row.row_type) {
      case 'reap-account':
        return <strong>{renderReapAccountColumnColor(props.row.dir.toFixed(2))}</strong>;
      case 'pal':
        return props.row.dir.toFixed(2);
      case 'adjustment':
        return props.row.dir.toFixed(2);      
      case 'total':
        return null;
      default:
        return null;
    }
  }

  function renderFunction() {
    if (props.row.row_type === 'reap-account' || 
        props.row.row_type === 'pal' ||
        props.row.row_type === 'adjustment') {
      return (
      <Tag color="purple" style={{
        width: '100px',
        textAlign: 'center',
        display: 'inline-block',
        fontSize: '12px',
        lineHeight: '22px',
        height: '22px',
        padding: '0',
      }}>
        {props.row.func.type}
      </Tag>);
    }

    return '';
  }

  function renderPopover() {
    if (props.row.row_type === 'empty') {
      return (
        <div style={{height: '22px'}}>
        </div>
      );
    }

    return (
      <DivisionalProfitAndLossMenu
        row_type={props.row_type}
        row={props.row}
        readOnly={props.readOnly}
        model={props.model}
        setSplitsState={props.setSplitsState}
      />
    );
  }

  function renderInfo() {
    const info = [];

    if (props.row.isParent) {
      info.push(
        <Tooltip title="Has child accounts with values." key={uuid()}>
          <Button shape="circle" size="small"
            icon={<InfoOutlined style={{ color: 'green' }} />} />
        </Tooltip>
      )
    }

    if (props.row.row_type === 'adjustment') {
      info.push(
        <Tooltip title="Adjustment" key={uuid()}>
          <Button shape="circle" size="small"
            icon={<EditOutlined style={{ color: 'green' }} />} />
        </Tooltip>
      )
    }

    return info;
  }

  function renderCode() {
    if (props.row.row_type === 'pal') {
      return props.row.code;
    }
  }

  switch (props.col_type) {
    case 'control':
      return renderPopover();
    case 'info':
      return renderInfo();
    case 'code':
      return renderCode();
    case 'description':
      return renderDescription();
    case 'function':
      return renderFunction();
    case 'month':
      return renderMonth(props.row);
    case 'sales':
      return renderSales(props.row);
    case 'pm':
      return renderPM(props.row);
    case 'dir':
      return renderDir(props.row);
    default:
      return null;
  }

}

export default DivisionalProfitAndLossColumn;
